<template>
  <div>
    <function-tooltip
      v-if="functionAndArgument[0]"
      :function-name="functionAndArgument[0]"
      :arg-number="functionAndArgument[1]"
      :total-arg="functionAndArgument[2]"
    />
  </div>
</template>

<script>
import FunctionTooltip from "./FunctionTooltip.vue";
export default {
  components: { FunctionTooltip },
  props: ["formulaText", "cursorPosition"],
  computed: {
    functionAndArgument() {
      const [functionName, argNumber, functionStartPosition] = this.findFunctionAndArgument(
        this.formulaText.toLowerCase(),
        this.cursorPosition
      ) || ["", 0, 0];
      const functionEndPosition = this.findFunctionEndPosition(this.formulaText, functionStartPosition);
      const [, totalArg] = this.findFunctionAndArgument(this.formulaText, functionEndPosition) || ["", 0];

      return [functionName, argNumber, totalArg];
    },
  },
  methods: {
    findFunctionAndArgument(expression, cursorPosition) {
      let arg = 0;
      let bracket = 0;
      let functionName = "";
      let i = cursorPosition;

      for (; i > 0; i--) {
        if (expression[i] === ")") {
          bracket++;
        } else if (expression[i] === "(") {
          if (bracket > 0) bracket--;
          else {
            let x = i - 1;
            let funcName = "";
            while (x >= 0 && expression[x].match(/[a-zA-Z_.0-9]/)) {
              funcName = expression[x] + funcName;
              x--;
            }
            if (funcName) {
              functionName = funcName;
              break;
            }
          }
        } else if (expression[i] === "," && bracket === 0) {
          arg++;
        }
      }
      return [functionName, arg, i];
    },
    findFunctionEndPosition(expression, startPosition) {
      let bracket = 0;
      let i = startPosition;
      for (; i < expression.length; i++) {
        if (expression[i] === "(") {
          bracket++;
        } else if (expression[i] === ")") {
          bracket--;
          if (bracket <= 0) return i - 1;
        }
      }
      return i - 1;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
</style>
